// @ts-nocheck
import { useEffect, useState } from "react"

import { useAccount, useSchedule } from "@shared/contexts"

export default function useAppierVodEvent() {
  const [isSendEvent, setIsSendEvent] = useState(false)

  const { schedule } = useSchedule()
  const { account } = useAccount()

  useEffect(() => {
    if (!schedule || !account.viewer) {
      return
    }

    if (isSendEvent) {
      return
    }

    window.qg("event", "contents_vod_viewed", {
      content_name: schedule.title,
      user_id: String(account.viewer.userId),
      partner_name: schedule.user.nickname,
      total_length: 0,
      content_id: String(schedule.id),
      partner_id: String(schedule.user.id),
    })

    setIsSendEvent(true)
  }, [schedule, account, isSendEvent])
}
